module.exports = __webpack_public_path__ + "img/solution_2.81b17ab1.png";